import PropTypes from 'prop-types'
import { useMemo, useRef } from 'react'
import { Input } from '.'
import { HandleClickOutside } from '../../HandleClickOutside'
import { Element } from '../element'
import classes from './index.module.scss'

// InputDropdown2 is cloned from InputDropdown component to fix the bug FG2-1410
// Check the bug at: https://fiingroup.youtrack.cloud/issue/FG2-1410/SC02TC-FS04.08-012.01-O-search-xuat-hien-sau-khi-cuon-chuot
export const InputDropdown2 = ({
  children,
  placeHolder,
  containerStyle,
  style,
  dropdownContainerStyle,
  dropdownContentStyle,
  type,
  isShowDropdown,
  onClickOutsideDropdown,
  onClick,
  onBlur,
  onChange,
  onKeyDown,
  onClickIcon,
  value,
  zIndexDropdown,
}) => {
  const inputRef = useRef()

  const getInputWidth = useMemo(() => {
    if (inputRef?.current) {
      return inputRef.current?.getBoundingClientRect().width
    }
    return 0
  }, [inputRef?.current?.getBoundingClientRect().width])

  const getInputHeight = useMemo(() => {
    if (inputRef?.current) {
      return inputRef.current?.getBoundingClientRect().height
    }
    return 0
  }, [inputRef?.current?.getBoundingClientRect().height])

  return (
    <div className="positionRelative">
      <Input
        inputRef={inputRef}
        style={style}
        containerStyle={containerStyle}
        type={type}
        placeHolder={placeHolder}
        onClick={onClick}
        onBlur={onBlur}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onClickIcon={onClickIcon}
        value={value}
      />
      {isShowDropdown && (
        <div
          className="positionAbsolute"
          style={{
            width: getInputWidth,
            left: 0,
            top: getInputHeight,
            zIndex: zIndexDropdown,
            ...dropdownContainerStyle,
          }}
        >
          <HandleClickOutside
            handleClickOutside={onClickOutsideDropdown}
            exceptRef={inputRef}
          >
            <Element
              elementName="div"
              style={{ backgroundColor: '#fff', ...dropdownContentStyle }}
              className={classes.inputDropdownContentContainer}
            >
              {children}
            </Element>
          </HandleClickOutside>
        </div>
      )}
    </div>
  )
}

InputDropdown2.propTypes = {
  children: PropTypes.node.isRequired,
  placeHolder: PropTypes.string,
  style: PropTypes.object,
  containerStyle: PropTypes.object,
  dropdownContainerStyle: PropTypes.object,
  type: PropTypes.string,
  isShowDropdown: PropTypes.bool,
  onClickOutsideDropdown: PropTypes.func,
  onClick: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.string,
  zIndexDropdown: PropTypes.number,
}

InputDropdown2.defaultProps = {
  placeHolder: '',
  style: {},
  containerStyle: {},
  dropdownContainerStyle: {},
  type: 'text',
  isShowDropdown: false,
  zIndexDropdown: 20,
  onClickOutsideDropdown: () => {},
}
